export default "__VITE_ASSET__CbuGXmLc__"